import React from 'react'
import { Modal, ModalBody } from 'react-bootstrap'
import { ContentViewUI } from '../../widgets/components/ContentViewUI'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import { Spinner } from '../../widgets/components/General/Spinner'

export default function ViewFileModal({
  showViewFileModal,
  setShowViewFileModal,
  fileOriginalNameToView,
  fileContentName,
}: {
  showViewFileModal: boolean
  setShowViewFileModal: (value: boolean) => void
  fileOriginalNameToView: string
  fileContentName: string
}) {
  const { signURLContext, setSignURLContext } = useMoveToFolderData()
  return (
    <>
      <Modal
        show={showViewFileModal}
        onHide={() => {
          setShowViewFileModal(false)
          setSignURLContext('')
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        fullscreen
        dialogClassName='test'
      >
        <Modal.Header className='text-wrap' closeButton>
          <h2 className='text-wrap font-size-16 text-dark'>
            {fileContentName.includes('/') ? fileContentName.split('/').pop() : fileContentName}
          </h2>
        </Modal.Header>
        <ModalBody className='p-0'>
          {!signURLContext && (
            <div className='z-index-3 d-flex justify-content-center p-5'>
              <Spinner />
            </div>
          )}
          <ContentViewUI fileName={fileOriginalNameToView} cssStyle={true} />
        </ModalBody>
      </Modal>
    </>
  )
}
